<template>
	<page>
		<module enable-flex>
			
			<m-operate>
				<c-button power="b_finance_sys_account_add" color="sys" @click="addAccount()">添加账户</c-button>
			</m-operate>
			
			<c-table ref="table" code="finance_sys_account_list">				
				<c-table-column
					label="状态"
					name="state"
				>
					<template v-slot="{data}">
                        <span v-if="data.id > 0">{{accountStateName[data.state]}}</span>
                        <span v-else>--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="账户名称"
					name="account_name"
				>
				</c-table-column>
				
				<c-table-column
					label="账户余额"
					name="account_balance"
				>
					<template v-slot="{data}">
                        <span v-if="data.account_balance">￥{{data.account_balance}}</span>
                        <span v-else>--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="冻结金额"
					name="frozen_balance"
				>
					<template v-slot="{data}">
                        <span v-if="data.frozen_balance">￥{{data.frozen_balance}}</span>
                        <span v-else>--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="可提现余额"
					name="can_withdraw_balance"
				>
					<template v-slot="{data}">
                        <span v-if="data.can_withdraw_balance">￥{{data.can_withdraw_balance}}</span>
                        <span v-else>--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="保证金额度"
					name="deposit_money"
				>
					<template v-slot="{data}">
                        <span v-if="data.deposit_money">￥{{data.deposit_money}}</span>
                        <span v-else>--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="保证金余额"
					name="deposit_balance"
				>
					<template v-slot="{data}">
                        <span v-if="data.deposit_balance">￥{{data.deposit_balance}}</span>
                        <span v-else>--</span>
					</template>
				</c-table-column>


				<!-- <c-table-column
					label="待结算金额"
					name="settle_amount"
				>
					<template v-slot="{data}">
                        <span v-if="data.settle_amount">￥{{data.settle_amount}}</span>
                        <span v-else>--</span>
					</template>
				</c-table-column> -->
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="210"
				>
					<template v-slot="{data}">
						<c-table-button v-if="data.id > 0" @click="edit(data)">编辑</c-table-button>
						<c-table-button power="b_finance_sys_account_del" v-if="data.id > 0 && data.account_balance == 0 && data.deposit_balance == 0 && data.settle_amount == 0" @click="stateHandle(2,data)">注销</c-table-button>
						<c-table-button v-if="data.id > 0 && data.state == 1 && (data.account_balance != 0 || data.deposit_balance != 0 || data.settle_amount != 0)" @click="stateHandle(3,data)">挂起</c-table-button>
						<c-table-button v-if="data.id > 0 && data.state == 3" @click="stateHandle(1,data)">恢复</c-table-button>
						<c-table-button @click="showRecord(data)">查看收支流水</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="editAccount" :title="editState ? '编辑账户' : '新增账户'" width="600" @resolve="submit">
			<c-form ref="form">
				<c-form-item type="hidden" name="id"></c-form-item>
				<c-form-item type="input" label="账户名称" name="account_name" required></c-form-item>
				<c-form-item v-show="!editState" type="input" label="初始化账户余额" name="account_balance" required></c-form-item>
				<c-form-item type="input" label="保证金额度" name="deposit_money" required></c-form-item>
				<c-form-item v-show="!editState" type="input" label="初始化保证金余额" name="deposit_balance" required></c-form-item>
			</c-form>
		</c-dialog>

        <c-dialog ref="rewardDialog" title="收益明细" width="1200" height="800" enable-flex :button="false">
            <m-search ref="rewardSearch" @search="rewardSearchHandle">
                <c-form ref="form" inline>
                    <c-form-item type="checkbox" label="收益类型" name="reward_type" :options="rewardTypeOptions">
                    </c-form-item>
                    <c-form-item type="checkbox" label="收益状态" name="state" :options="stateOptions">
                    </c-form-item>
                    <c-form-item type="datetime" label="创建时间" start-name="start_date" end-name="end_date">
                    </c-form-item>
                </c-form>
            </m-search>
            <c-table ref="rewardTable" height="grow">
                <c-table-column
                	label="结算流水号"
                	name="record_number"
                	width="120"
                ></c-table-column>
                
                <c-table-column
                	label="结算类型 "
                	name="reward_type"
                	width="100"
                >
                	<template v-slot="row">
                		{{rewardTypeName[row.data.reward_type]}}
                	</template>
                </c-table-column>
                
                <c-table-column
                	label="业务类型"
                	name="order_type"
                	width="80"
                >
                	<template v-slot="row">
                		<span v-if="row.data.order_type==1" style="color:lightsalmon">代理订单</span>
                		<span v-else style="color:lightseagreen">销售订单</span>
                	</template>
                </c-table-column>
                
                <c-table-column
                	label="业务单号"
                	name="relate_number"
                	width="125"
                ></c-table-column>
                
                <c-table-column
                	label="订单总额"
                	name="payment_money"
                	width="80"
                >
                	<template v-slot="row">
                	    ¥{{parseFloat(parseFloat(row.data.product_money).toFixed(2))}}
                	</template>
                </c-table-column>
                
                <c-table-column
                	label="已支付金额"
                	name="payment_money"
                	width="90"
                >
                	<template v-slot="row">
                	    <span style="color:green;">¥{{parseFloat(parseFloat(row.data.payment_money).toFixed(2))}}</span>
                	</template>
                </c-table-column>
                
                <c-table-column
                	label="待支付尾款"
                	width="90"
                >
                	<template v-slot="row">
                	    <span v-if="(row.data.product_money-row.data.payment_money) > 0" style="color:red">
                			¥{{parseFloat(parseFloat(row.data.product_money-row.data.payment_money).toFixed(2))}}
                		</span>
                		<span v-else>-</span>
                	</template>
                </c-table-column>
                
                <c-table-column
                	label="佣金比例"
                	width="80"
                >
                	<template v-slot="row">
                		<span style="color:blue;">{{parseFloat((parseFloat(row.data.record_ratio)*100).toFixed(2))}}%</span>
                	</template>
                </c-table-column>
                
                <c-table-column
                	label="可结算金额"
                	name="estimated_record_money"
                	width="90"
                >
                	<template v-slot="row">
                	    <span style="color:blue;">¥{{parseFloat(parseFloat(row.data.estimated_record_money).toFixed(2))}}</span>
                	</template>
                </c-table-column>
                
                <c-table-column
                	label="预计最终结算金额"
                	name="original_record_money"
                	width="130"
                >
                	<template v-slot="row">
                		<span style="color:gray;">¥{{parseFloat(parseFloat(row.data.original_record_money).toFixed(2))}}</span>
                	</template>
                </c-table-column>
                
                <c-table-column
                	label="已结算金额"
                	name="record_money"
                	width="100"
                >
                	<template v-slot="row">
                	    <span v-if="row.data.state == 2" style="color:green;">
                			¥{{parseFloat(parseFloat(row.data.record_money).toFixed(2))}}
                		</span>
                		<span v-else>-</span>
                	</template>
                </c-table-column>
                
                <c-table-column
                	label="结算状态"
                	name="state"
                	width="75"
                >
                	<template v-slot="{data}">
                        <span v-if="data.state==0" style="color:darkgray">{{transStateName[data.state]}}</span>
                        <span v-if="data.state==1" style="color:#2348d0">{{transStateName[data.state]}}</span>
                		<span v-if="data.state==2" style="color:darkgreen">{{transStateName[data.state]}}</span>
                	</template>
                </c-table-column>
                
                <c-table-column
                	label="结算说明"
                	name="remark"
                	width="270"
                ></c-table-column>
                
                <c-table-column
                	label="生成时间"
                	name="create_date"
                	width="140"
                ></c-table-column>
                
                <c-table-column
                	label="最近更新时间"
                	name="update_date"
                	width="140"
                ></c-table-column>
                
                <c-table-column
                	label="取消时间"
                	name="cancel_date"
                	width="140"
                >
                	<template v-slot="{data}">
                	    <span v-if="data.cancel_date" style="color:darkgray">{{data.cancel_date}}</span>
                	    <span v-else>-</span>
                	</template>
                </c-table-column>
            </c-table>
        </c-dialog>
	</page>
</template>

<script>
	export default {
		name: 'finance_sys_account_list',
		
		data() {
			return {
				accountStateName: {
					1: '正常',
					2: '注销',
					3: '挂起'
				},
				editState: false,
                stateOptions: [
                	{name: '待结算',value: 1},
                	{name: '取消结算',value: 0},
                	{name: '已结算',value: 2}
                ],
				transStateName: {
				    0: '取消结算',
				    1: '待结算',
				    2: '已结算'
				},
				rewardTypeOptions: [
					{name: '直推奖励',value: 2},
					{name: '间推奖励',value: 3},
					{name: '爆款代理费',value: 201},
					{name: '专业代理费',value: 202},
					{name: '市代代理费',value: 203},
					{name: '省代代理费',value: 204},
					{name: '业务员代理费',value: 205}
				],
				rewardTypeName:{
					2: '直推奖励',
					3: '间推奖励',
					201: '爆款代理费',
					202: '专业代理费',
					203: '市代代理费',
					204: '省代代理费',
					205: '业务员代理费'
				},
                member_user_id:-1
			}
		},
		
		mounted() {
			this.$refs.table.load({
				url: '/sys/account/list'
			});
		},
		
		methods: {
            rewardSearchHandle(data) {
                data.member_user_id = this.member_user_id;
                this.$refs.rewardTable.load({
                    url: '/member_user/reward/list',
                    data
                });
            },

			addAccount() {
				this.editState = false;
				this.$refs.form.set({
					id: '',
					account_name: '',
					account_balance: 0,
					deposit_money: 0,
					deposit_balance: 0
				});
				this.$refs.editAccount.open();
			},

			edit(val) {
				this.editState = true;
				this.$refs.form.set(val);
				this.$refs.editAccount.open();
			},

			submit(stop) {
				stop();
				this.$refs.form.submit({
					url: this.editState ? '/sys/account/edit' : '/sys/account/add',
					rule: {
						account_name: [{
							type: 'empty',
							word: '请填写账户名称',
							skip: () => {
								return this.editState;
							}
						}],
						deposit_money: [{
							type: 'empty',
							word: '请填写保证金额度',
							skip: () => {
								return this.editState;
							}
						}],
						account_balance: '请填写初始化账户余额',
						deposit_balance: '请填写初始化保证金余额'
					},
					success: (data, res) => {
						this.$message({
							text: '保存成功'
						});
						this.$refs.table.update();
						this.$refs.editAccount.close();
					}
				});
			},
			
			stateHandle(state, val){
				var text,operation;
				if(state == 2) {
					operation = "注销";
					text = '注销后将删除账户，确定注销[' + val.account_name + ']账户吗？';
				}else if(state == 3) {
					operation = "挂起";
					text = '挂起后账户将不可用，确定挂起[' + val.account_name + ']账户吗？';
				}else{
					operation = "恢复";
					text = '确定恢复[' + val.account_name + ']账户吗？';
				}
				this.$confirm({
					text: text,  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/sys/account/state',
							data: {
								id: val.id,
								state: state
							},
							loading: false,  // 是否显示loading，
							success: data => {
								this.$message({
				                  	text: operation + '成功',
				                  	icon: 'success'
				                });
								this.$refs.table.update();
							},  // 成功回调，接收参数为返回值的obj属性
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			showRecord(val){
                if (val.id > 0){
                    this.navigateTo({
                        path: '/sys_account_record/'+val.id,
                        query: {
                            id: val.id,
                            account_name: val.account_name
                        }
                    });
                }else {
                    this.member_user_id = val.id;
                    this.$refs.rewardDialog.open();
                    this.$refs.rewardTable.load({
                        url: '/member_user/reward/list',
                        data: {
                            member_user_id: this.member_user_id
                        }
                    });
                }
			}
		}
	}
</script>

<style lang="stylus" scoped>
	
</style>